@if (optionsReady()) {
  <ncp-table
    #medicalReports
    [(options)]="options"
  ></ncp-table>
}

<ncp-modal
  #previewMod
  [options]="previewModOptions()"
>
  <div class="d-flex flex-grow-1">
    @if (pdfUrl()) {
      <div class="d-flex flex-grow-1">
        <embed
          [src]="pdfUrl()"
          type="application/pdf"
          class="flex-grow-1"
        />
      </div>
    }
  </div>
</ncp-modal>
